/**
 * @fileoverview gRPC-Web generated client stub for auth
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.1
// 	protoc              v6.33.5
// source: auth.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.auth = require('./auth_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.AuthServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.auth.AuthServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.LoginRequest,
 *   !proto.auth.LoginResponse>}
 */
const methodDescriptor_AuthService_InitiateLogin = new grpc.web.MethodDescriptor(
  '/auth.AuthService/InitiateLogin',
  grpc.web.MethodType.UNARY,
  proto.auth.LoginRequest,
  proto.auth.LoginResponse,
  /**
   * @param {!proto.auth.LoginRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.LoginResponse.deserializeBinary
);


/**
 * @param {!proto.auth.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.auth.LoginResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.auth.LoginResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthServiceClient.prototype.initiateLogin =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/auth.AuthService/InitiateLogin',
      request,
      metadata || {},
      methodDescriptor_AuthService_InitiateLogin,
      callback);
};


/**
 * @param {!proto.auth.LoginRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.auth.LoginResponse>}
 *     Promise that resolves to the response
 */
proto.auth.AuthServicePromiseClient.prototype.initiateLogin =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/auth.AuthService/InitiateLogin',
      request,
      metadata || {},
      methodDescriptor_AuthService_InitiateLogin);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.auth.StatusRequest,
 *   !proto.auth.StatusUpdate>}
 */
const methodDescriptor_AuthService_WatchLoginStatus = new grpc.web.MethodDescriptor(
  '/auth.AuthService/WatchLoginStatus',
  grpc.web.MethodType.SERVER_STREAMING,
  proto.auth.StatusRequest,
  proto.auth.StatusUpdate,
  /**
   * @param {!proto.auth.StatusRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.auth.StatusUpdate.deserializeBinary
);


/**
 * @param {!proto.auth.StatusRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.auth.StatusUpdate>}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthServiceClient.prototype.watchLoginStatus =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/auth.AuthService/WatchLoginStatus',
      request,
      metadata || {},
      methodDescriptor_AuthService_WatchLoginStatus);
};


/**
 * @param {!proto.auth.StatusRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.auth.StatusUpdate>}
 *     The XHR Node Readable Stream
 */
proto.auth.AuthServicePromiseClient.prototype.watchLoginStatus =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/auth.AuthService/WatchLoginStatus',
      request,
      metadata || {},
      methodDescriptor_AuthService_WatchLoginStatus);
};


module.exports = proto.auth;

